import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MenuService } from '../../../services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { PanelModule } from '../../../modules/panel.module';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'brt-menu-condition',
  standalone: true,
  imports: [PanelModule],
  templateUrl: './menu-condition.component.html',
  styleUrl: './menu-condition.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenuConditionComponent),
      multi: true
    }
  ]
})
export class MenuConditionComponent {
  menus: any[];
  items: any[];
  options: any[];
  filteredItems: any[];
  filteredOptions: any[];
  constructor(private route: ActivatedRoute, menuService: MenuService) {
    this.route.params.subscribe(async params => {
      var businessId = params['bid'];
      combineLatest([
        menuService.searchMenu({ BusinessId: businessId }),
        menuService.searchMenuItem({ BusinessId: businessId }),
        menuService.searchMenuOption({ BusinessId: businessId })
      ]).subscribe(([menus, items, options]) => {
        this.menus = menus.List;
        this.items = items.List;
        this.options = options.List;
        this.filterMenuItems();
        this.filterMenuOptions();
      });
    });
  }

  filterMenuItems() {
    this.filteredItems = this.items?.filter(x => x.MenuIds?.some(i => this.value.MenuIds?.includes(i)));
    this.filterMenuOptions();
  }
  filterMenuOptions() {
    var optionIds = [
      this.menus.find(x => this.value.MenuIds?.includes(x.Id))?.Options?.map(x => x.Choices?.map(y => y.MenuOptionId)).flat(),
      this.items.filter(x => x.MenuIds?.some(i => this.value.MenuIds?.includes(i)) || this.value.MenuItemIds?.includes(x.Id))
        .map(_ => _.Options?.map(x => x.Choices?.map(y => y.MenuOptionId)).flat()).flat()
    ].filter(x => x).flat();
    this.filteredOptions = this.options.filter(x => optionIds.includes(x.Id));
  }

  value: any;

  changed() { this.onChange(this.value); }
  writeValue(value: any) { this.value = value || {}; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any[]) => { };
  onTouched = () => { };
}
